import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalculator = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.311,14.858l6.109,0",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.311,17.646l6.109,0",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.867,7.343l6.109,0",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.995,16.182l6.109,0",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.42,22.196l-14.841,0c-1.342,0 -2.431,-1.127 -2.431,-2.516l0,-15.359c0,-1.389 1.089,-2.516 2.431,-2.516l14.841,0c1.342,0 2.431,1.127 2.431,2.516l0,15.359c0,1.389 -1.089,2.516 -2.431,2.516Z",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.526,10.075l-4.32,-4.471",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.05,19.343l0,-6.322",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.206,10.076l4.32,-4.471",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		})
	] })
});
export default SvgCalculator;
